import React from 'react';
import HeaderButton from './ui/HeaderButton';
import { translate } from '../../Services/translation';

const Enquiry = () => {
  const onClick = () => {
    console.log('Enquiry!'); // TODO: Add Enquiry logic
  };

  return (
    <HeaderButton
      icon="Document-Plus"
      label={translate('general.enquiry')}
      onClick={onClick}
    />
  );
};

export default Enquiry;
